// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2qfF9","error":"Textarea_error__29sy_","readonly":"Textarea_readonly__3nTBP","disabled":"Textarea_disabled__3dtGj"};